import { supplierIdFormat } from "@redotech/redo-model/ids";
import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const getProductCatalogCount = {
  name: "getProductCatalogCount" as const,
  input: z.object({
    search: z.string().optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
    supplierIds: z.array(supplierIdFormat.schema).optional(),
  }),
  output: z.object({ totalCount: z.number().int() }),
};
